import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageUploadComponent),
      multi: true,
    },
  ],
})
export class ImageUploadComponent implements OnInit, ControlValueAccessor {
  value?: string;
  isDisabled = false;

  constructor() {}

  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit() {}

  writeValue(obj: any): void {
    this.changeValue(obj, false);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  handleInputChange(event: Event) {
    const input = event.target as HTMLInputElement;

    const file = input.files?.[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = ({ target: { result } }) => {
        if (typeof result === 'string') {
          this.changeValue(result);
        }
      };

      reader.readAsText(file, 'UTF-8');
    }
  }

  handleInputReset() {
    this.changeValue(undefined);
  }

  private changeValue(value: any, stateChanges = true) {
    this.value = value ? `data:image/svg+xml;base64,${btoa(value)}` : undefined;

    if (stateChanges) {
      this.onChange(value);
    }
  }
}
